// biome-ignore lint/style/useImportType: Intentionally using a regular import for runtime availability
import { Pipe, PipeTransform } from '@angular/core';
// biome-ignore lint/style/useImportType: Regular import needed because DomSanitizer is used at runtime
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'enforceNewLine',
  standalone: true,
})
export class EnforceNewLinePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return value;
    const html = value.replace(/\n/g, '<br/>');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
